//noinspection JSUnusedGlobalSymbols
export default {

    install(Vue) {

        const toast = (cls, msg, duration) => {
            $('body').toast({
                class: cls,
                message: msg,
                displayTime: duration * 1000,
                showProgress: duration > 0 ? 'bottom' : false,
                position: 'top right',
                closeIcon: true,
                newestOnTop: true
            })
        }

        const plugin = {

            confirm(msg) {
                return new Promise(resolve => {
                    let resolved = false
                    const doResolve = value => {
                        if (!resolved) {
                            resolved = true
                            resolve(value)
                        }
                    }
                    $('body').toast({
                        message: msg,
                        displayTime: 0,
                        position: 'top right',
                        closeIcon: true,
                        newestOnTop: true,
                        classActions: 'top attached',
                        actions: [{
                            text: 'Bestätigen',
                            icon: 'checkmark',
                            class: 'positive',
                        }, {
                            text: 'Abbrechen',
                            icon: 'remove',
                            class: 'negative',
                        }],
                        onApprove: function() { doResolve(true) },
                        onDeny: function() { doResolve(false) },
                        onHidden: function() { doResolve(false) }
                    })
                })
            },

            successOrError(successMsg, errorMsg, successDuration = 3, errorDuration = 0) {
                return promise => {
                    promise
                        .then(() => this.success(successMsg, successDuration))
                        .catch(() => this.error(errorMsg, errorDuration))
                }
            },

            error(msg, duration = 0) {
                toast('error', msg, duration)
            },

            info(msg, duration = 3) {
                toast('info', msg, duration)
            },

            success(msg, duration = 3) {
                toast('success', msg, duration)
            },

            warning(msg, duration = 5) {
                toast('warning', msg, duration)
            },

            fatal(msg, exception) {
                // Exception loggen
                /* eslint no-console: ["off"] */
                console.error(exception)

                // Modal holen
                const el = $('.fatal.modal')

                // Fehlerobjekt erstellen
                const error = { msg, exception }

                // Fehlerobjekt in Modal setzen
                el.find('textarea').text(btoa(JSON.stringify(error)))

                // Modal konfigurieren
                el.modal({
                    closable: false
                })

                // Modal anzeigen
                el.modal('show')
            }
        }

        Vue.$growl = plugin
        Vue.prototype.$growl = plugin

    }

}
